import Vue from "vue";
import Toast from "vue-toastification";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store/store";
import Vuebar from "vuebar";
import "./plugins/base";
import moment from 'moment';
import VueSkycons from "vue-skycons";
import InstantSearch from "vue-instantsearch";
import "vue-toastification/dist/index.css";

import {
  ValidationObserver,
  ValidationProvider,
} from "vee-validate";


/** Vue filters starts */
Vue.prototype.moment = moment;

Vue.filter('lower', function(text){
    return text.toLowerCase();
});

 // Feb 25, 2021 10:19 AM
Vue.filter('formatDate', function(date){
    return moment(date).format('lll');
});

 // 30 minutes ago
Vue.filter('relativeFormat', function(date){
    return moment(date).fromNow();
});

 // February 25, 2021
Vue.filter('regularDate', function(date){
    return moment(date).format('LL');
});

 // February 25, 2021 10:19 AM
Vue.filter('regularDateWithTime', function(date){
    return moment(date).format('LLL');
});

 // Today at 10:20 AM
Vue.filter('calendarDate', function(date){
    return moment(date).calendar();
});

Vue.filter('dateOnly', function(date){
    return moment(date).format('MM-DD-YYYY');
});

Vue.filter('month', function(date){
    return moment(date).format('MMMM YYYY');
});

Vue.filter('full_month', function(date){
    return moment(date).format('MMMM');
});

Vue.filter('full_year', function(date){
    return moment(date).format('YYYY');
});

Vue.filter('count_date', function(date){
    return moment().diff(date, "days");
});
/** Vue filters ends */

/**
 ** Vue Toast Notifications Configurations
 */
 const options = {
    newestOnTop: true,
    position: 'bottom-left',
    maxToasts: 20,
    timeout: 5000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: false,
    rtl: false,
    transition: "Vue-Toastification__slideBlurred",
    filterBeforeCreate: (toast, toasts) => {
        if (toasts.filter(
          t => t.type === toast.type
        ).length !== 0) {
          return false;
        }
        return toast;
      }
};


Vue.use(Toast, options);


Vue.use(VueSkycons, {
  color: "#1e88e5",
});
Vue.use(InstantSearch);
Vue.config.productionTip = false;
Vue.use(Vuebar);
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);


new Vue({
  vuetify,
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
